import { AUDIENCE } from '../../../enums/RoomAudience';
import { Events, Properties } from '../../../enums/Analytics';
import { isVanityUrl } from '../../../lib/helper/RoomHelper';
import { RoomSchema } from '../../../definitions/schemas';
import Analytics, { EventProperty } from '../../../tools/Analytics';

export const trackRoomLinkCopied = (room: RoomSchema, referrer: string) => {
  const {
    audience,
    contentIds,
    deal,
    expiresAt,
    invitedContactsOnly,
    passcode,
    requiresEmail,
    roomCollaborators,
    roomContactsCount,
    structure,
    verifyEmail,
  } = room;

  Analytics.track(Events.DEAL_ROOM_LINK_COPIED, {
    [Properties.COLLABORATOR_NUMBER]: roomCollaborators?.length || 0,
    [Properties.CONTACT_NUMBER]: roomContactsCount ?? 0,
    [Properties.CONTENT_NUMBER]: contentIds?.length ?? 0,
    [Properties.ENTERED_FROM]: referrer,
    [Properties.HAS_DEAL]: !!deal,
    [Properties.HAS_EXPIRATION]: !!expiresAt,
    [Properties.HAS_EXPLICIT_INVITE]: invitedContactsOnly,
    [Properties.HAS_PASSCODE]: !!passcode,
    [Properties.HAS_REQUIRES_EMAIL]: requiresEmail,
    [Properties.HAS_THUMBNAIL]: false,
    [Properties.HAS_WELCOME_MESSAGE]: !!structure?.welcome,
    [Properties.ROOM_AUDIENCE]: AUDIENCE[audience],
    [Properties.SALES_ACTIONS_NUMBER]: structure?.buttons?.length ?? 0,
    [Properties.VANITY_URL]: isVanityUrl(room.link),
    [Properties.HAS_EMAIL_VERIFICATION]: verifyEmail,
  });
};

export const trackRoomShared = (
  trackingProperties: EventProperty,
  invitees: number,
  areSmsNotificationsEnabled: boolean,
  sharedByContact: boolean
) => {
  Analytics.track(Events.DEAL_ROOM_SHARED, {
    ...trackingProperties,
    [Properties.VANITY_URL]: isVanityUrl(window.location.href),
    [Properties.NUMBER_PEERS]: invitees,
  });

  if (areSmsNotificationsEnabled) {
    const template = sharedByContact
      ? 'room shared by contact'
      : 'room shared by user';

    Analytics.track(Events.ROOM_SMS_SENT, {
      [Properties.HAS_DEAL]: trackingProperties[Properties.HAS_DEAL],
      [Properties.SENT_COPY_TO_SELF]: false,
      [Properties.SENT_TO_COLLABORATORS]: false,
      [Properties.SENT_TO_NON_VISITORS]: 'N/A',
      [Properties.SENT_TO_VISITORS]: 'N/A',
      [Properties.SMS_COUNT]: invitees,
      [Properties.TEMPLATE]: template,
    });
  }
};
